module.exports = __webpack_public_path__ + "img/image.7b53dae6.jpg";